<div class="mx-auto flex w-full max-w-7xl flex-1 flex-col">
  <header class="flex h-14 shrink-0 items-center justify-between gap-3 px-4 sm:h-16 sm:px-8">
    <div class="flex min-w-0 items-center gap-3">
      <button type="button" class="btn-shout-fab-secondary creator-back" (click)="goBack()" aria-label="Back">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="size-5" aria-hidden="true">
          <path d="M19 12H5" />
          <path d="m12 19-7-7 7-7" />
        </svg>
      </button>
      <img src="/assets/logos/official/SHOUT_icon_white.svg" alt="" class="h-7 w-auto brightness-0 dark:invert" />
      <p class="m-0 text-2xl font-black leading-none tracking-tight">SHOUT</p>
    </div>
    <p class="m-0 flex h-8 shrink-0 items-center whitespace-nowrap rounded-full border border-border px-3 text-sm font-bold sm:text-base dark:border-white/30">
      Free for creators
    </p>
  </header>

  <main class="grid flex-1 items-center gap-2 px-5 py-4 sm:px-8 sm:py-8 lg:grid-cols-2 lg:gap-12 lg:px-8 lg:py-12">
    <div class="flex min-w-0 flex-col gap-5">
      <h1 class="use-grotesque m-0 origin-bottom-left -skew-x-6 text-6xl font-extrabold leading-none tracking-tight text-balance sm:text-7xl lg:text-8xl xl:text-9xl">
        Create. Post. <span class="text-brand-studio">Get Paid.</span>
      </h1>
      <p class="m-0 max-w-md text-xl font-semibold leading-tight text-muted-foreground">
        The SHOUT app is where creators find brand campaigns, make the content and get paid. Download it free to get started.
      </p>

      <div class="flex max-w-xl flex-col gap-3 pt-2">
        <div class="flex flex-col gap-3 sm:flex-row">
          @for (store of stores(); track store.id) {
            <a
              [href]="store.href"
              target="_blank"
              rel="noopener"
              [attr.aria-label]="store.ariaLabel"
              (click)="onStoreClick(store)"
              class="inline-flex h-16 shrink-0 items-center gap-2">
              <img
                [src]="store.image"
                alt=""
                class="h-16 w-48 rounded-xl bg-black object-contain" />
            </a>
          }
        </div>
        <p class="m-0 text-base font-semibold text-muted-foreground">Free to download · Available on iPhone and Android</p>
      </div>

      <div class="flex flex-col gap-3">
        @for (perk of perks; track perk) {
          <div class="flex items-center gap-3">
            <div class="flex size-7 shrink-0 items-center justify-center rounded-full bg-brand-studio text-sm font-black text-white" aria-hidden="true">✓</div>
            <p class="m-0 text-xl font-bold leading-tight">{{ perk }}</p>
          </div>
        }
      </div>
    </div>

    <div class="creator-phone-wrap" aria-hidden="true">
      <div class="pointer-events-none absolute size-56 rounded-full bg-brand-studio opacity-35 blur-3xl lg:size-96"></div>
      <div class="creator-phone">
        <div class="creator-screen">
          <div class="creator-notch"></div>
        </div>
      </div>
      <div class="creator-card creator-card-brief">
        <div class="flex size-8 shrink-0 items-center justify-center rounded-lg bg-linear-to-br from-brand-studio-dark to-brand-studio text-sm font-black text-white">O</div>
        <div class="min-w-0">
          <p class="m-0 text-sm font-semibold leading-none text-zinc-500">New brief</p>
          <p class="m-0 text-lg font-bold leading-tight text-zinc-950">Oakline · Summer Launch</p>
        </div>
      </div>
      <div class="creator-card creator-card-pay">
        <div class="creator-approved flex size-8 shrink-0 items-center justify-center rounded-full text-base font-black">✓</div>
        <div class="min-w-0">
          <p class="m-0 text-sm font-semibold leading-none text-zinc-500">Content approved</p>
          <p class="m-0 text-lg font-bold leading-tight text-zinc-950">Payment on its way</p>
        </div>
      </div>
    </div>
  </main>

  <footer class="creator-footer flex flex-wrap items-center justify-between gap-x-5 gap-y-2 px-5 sm:px-8 sm:pb-8">
    <p class="m-0 text-base font-semibold text-muted-foreground">
      Running a brand or agency?
      <a href="/onboarding-select" class="font-bold text-foreground hover:text-foreground/80" (click)="onBrandAgencyClick($event)">Start here</a>
    </p>
    <p class="m-0 text-base font-semibold text-muted-foreground">Already on SHOUT? Open the app to sign in.</p>
  </footer>
</div>
